import { useMemo } from 'react'
import { ISalesTeam } from '@user/store/salesTeam/typings'
import { ITenantUser } from '@user/store/users/typings'
import { ListItem } from '../typings'
import { SalesTeamHierarchy } from '@user/store/notifications/typings'

export const useFlattenSalesTeams = (
  salesTeams: ISalesTeam[],
  users: ITenantUser[],
  salesTeamHierarchy: SalesTeamHierarchy,
) => {
  const usersByPositionId = useMemo(() => {
    const map = new Map<number, ITenantUser[]>()
    users.map((user) =>
      user.salesTeamPositionIds.map((id) =>
        map.set(id, map.has(id) ? [...map.get(id)!, user] : [user]),
      ),
    )
    return map
  }, [users])

  return useMemo(() => {
    const list: ListItem[] = []

    const { salesTeamIds, salesTeamPositions: selectedPositions } =
      salesTeamHierarchy

    const selectedPositionsById = new Map(
      selectedPositions.map((p) => [p.id, p]),
    )

    salesTeams.map((team) => {
      const teamSelected = salesTeamIds.includes(team.id)
      const teamIndeterminate = teamSelected
        ? false
        : team.positions.filter(({ id }) => selectedPositionsById.has(id!))
            .length > 0

      const teamId = `team_${team.id}`
      list.push({
        id: teamId,
        label: team.name,
        parentId: null,
        selected: teamSelected,
        indeterminate: teamIndeterminate,
      })

      team.positions.map((pos) => {
        const { isSelected, employees } = selectedPositionsById.get(
          pos.id!,
        ) ?? {
          isSelected: false,
          employees: [] as string[],
        }

        const posId = `pos_${pos.id}`
        const posSelected = teamSelected ? true : isSelected
        const indeterminate = teamSelected
          ? false
          : posSelected
          ? false
          : employees.length > 0

        list.push({
          id: posId,
          label: pos.title,
          parentId: teamId,
          selected: posSelected,
          indeterminate,
        })

        const users = usersByPositionId.get(pos.id!)
        if (!!users) {
          users.map((u) =>
            list.push({
              id: `user_${u.id}`,
              label: `${u.firstName} ${u.lastName}`,
              parentId: posId,
              selected: posSelected ? true : employees.includes(u.id),
              indeterminate: false,
            }),
          )
        }
      })
    })

    return list
  }, [salesTeamHierarchy, salesTeams, usersByPositionId])
}
